export default function castMegabytesToBytes(megabytes: number): number {
  return megabytes * 1024 * 1024;
}
